<template>
  <div class="faq">
	<Modal
	  v-model="modalEditImage"
	  title="替换图片"
	  :closable="false"
	  :mask-closable="false"
	  @on-ok="addRecord"
	>
	  <p>图片：{{upload_image_name}}</p>
	  <Upload action="" :before-upload="(file) =>  { return addImgRecord(file, 0)}" :multiple="true">
	      <Button icon="ios-cloud-upload-outline">上传图片</Button>
	  </Upload>
	</Modal>
    <Modal
      v-model="modalAdd"
      title="新增商品"
      :closable="false"
      :mask-closable="false"
      @on-ok="addRecord"
    >
      <p>类型：</p>
      <Select v-model="addClassify" filterable>
        <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <!-- <Input v-model="addQuestion" placeholder="问题" clearable /> -->
      <!-- <p>图片：</p>
      <Input type="textarea" :autosize="{minRows: 3}" v-model="addImages" placeholder="请输入图片名称，回车输入下一个" clearable/> -->
      
	  <p>图片：{{upload_image_name}}</p>
	  <Upload action="" :before-upload="(file) =>  { return addImgRecord(file, 0)}" :multiple="true">
	      <Button icon="ios-cloud-upload-outline">上传图片</Button>
	  </Upload>
	  
	  
	  <p>房间类型：</p>
      <Select v-model="addRoomType" filterable>
        <Option v-for="item in filterRoomType" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <p>用钻价格：</p>
      <Input v-model="addJewelPrice" placeholder="请输入用钻价格" clearable />
      <p>用币价格：</p>
      <Input v-model="addCoinPrice" placeholder="请输入用币价格" clearable />
      <p>折扣：</p>
      <Select v-model="addDiscount" filterable>
        <Option v-for="item in filterDiscount" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <p>状态：</p>
      <Select v-model="addStatus" filterable>
        <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <!-- <Checkbox v-model="isUpdateTime">是否更新时间</Checkbox> -->
      <p>备注：用钻购买价格，-1为不可用钻购买；用币购买价格，-1为不可用币购买</p>
    </Modal>
	<Modal
	  v-model="modalTagAdd"
	  title="选择标签"
	  :closable="false"
	  :mask-closable="false"
	  @on-ok="updateTags"
	>
	  <p>款式标签：</p>
	  <Select v-model="updateTagsType" filterable>
	    <Option v-for="item in dataTypeTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
	  </Select>
	  <p>风格标签一：</p>
	  <Select v-model="updateTagsStyleFirst" filterable>
	    <Option v-for="item in dataStyleTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
	  </Select>
	  <p>风格标签二：</p>
	  <Select v-model="updateTagsStyleSeconds" filterable>
	    <Option v-for="item in dataStyleTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
	  </Select>
	  <p>备注：款式标签必选一个,风格标签可选择0/1/2个</p>
	</Modal>
    <div class="headers">
      <span>分类：</span>
      <Select @on-change="changeSelect" v-model="classify" style="width: 80px">
        <Option
          v-for="item in filterClassify"
          :value="item.value"
          :key="item.value"
        >{{ item.label }}</Option>
      </Select>
      <span style="margin-left: 10px">房间类型：</span>
      <Select @on-change="changeSelect" v-model="room_type" style="width: 120px">
        <Option
                v-for="item in filterRoomType"
                :value="item.value"
                :key="item.value"
        >{{ item.label }}</Option>
      </Select>
      <Button @click="modalAdd = true">新增</Button>
      <Button @click="sort_btn">{{sort_btn_msg}}</Button>
      <Button v-show="sortSaveBtn" @click="sort_save">保存</Button>
       <Button @click="getRecords">刷新</Button>
    </div>
    <Table :columns="columns" :data="data">
      <template slot-scope="{ row, index }" slot="id">
        <span>{{ row.id }}</span>
      </template>
		<template slot-scope="{ row, index }" slot="url">
		    <Poptip trigger="hover" :transfer="true" title="图片详情">
		        <div class="info-pop" slot="content">
		            <img :src="row.url">
		        </div>
		        <img :src="row.url" style="width: 50px;height: 50px;">
		    </Poptip>
		</template>
      <template slot-scope="{ row, index }" slot="priority">
        <span>{{ row.priority }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="category_id">
        <template v-if="editIndex === index">
          <Select v-model="updateClassify" filterable>
            <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.category_id|getClassify }}</span>
      </template>

    <!--  <template slot-scope="{ row, index }" slot="images">
        <template v-if="editIndex === index"> -->
<!--          <i-Input v-model="updateImages" />-->
  <!--        <Input type="textarea" :autosize="{minRows: 3}" v-model="updateImages" placeholder="请输入图片名称，回车输入下一个" clearable/>
        </template>
        <span class="images-text" v-else>{{ row.images }}</span>
      </template> -->

      <template slot-scope="{ row, index }" slot="room_type">
        <template v-if="editIndex === index">
          <Select v-model="updateRoomType" filterable>
            <Option v-for="item in filterRoomType" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.room_type|getRoomType }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="jewel_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateJewelPrice" />
        </template>
        <span v-else>{{ row.jewel_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="coin_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateCoinPrice" />
        </template>
        <span v-else>{{ row.coin_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="discount">
        <template v-if="editIndex === index">
          <Select v-model="updateDiscount" filterable>
            <Option v-for="item in filterDiscount" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.discount|getDiscount }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="status">
        <template v-if="editIndex === index">
          <Select v-model="updateStatus" filterable>
            <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.status|getStatus }}</span>
      </template>
	  
	<!--  <template slot-scope="{ row, index }" slot="tags">
		<template v-if="editIndex === index">
			<span class="images-text">{{ row.tags|getTagsEdit }}</span>
		</template>
	    <span v-else class="images-text">{{ row.tags|getTags }}</span>
	  </template> -->

      <template slot-scope="{ row, index }" slot="action">
        <div v-if="!sorting">
          <div v-if="editIndex === index">
            <Button @click="handleSave(index)" :disabled="action_btn_disabled">保存</Button>
            <Button
              style="margin-left: 10px"
              @click="editIndex = -1"
              :disabled="action_btn_disabled"
            >取消</Button>
          </div>
          <div v-else>
			   <Button @click="handleToTop(row, index)">置顶</Button>
            <!-- <Button @click="handleEdit(row, index)">修改</Button> -->
		<!-- 	<Button style="margin-left: 10px" @click="showSelectTags(row, index)">标签</Button>
			<div style="display:  none;">
				<Button style="margin-top: 10px" @click="handleEditPage(row, index)">编辑</Button>
			</div>
            <Button style="margin-left: 10px" @click="editImages(row, index)">替图</Button> -->
          </div>
        </div>
        <div v-else>
          <Button
            :disabled="index === 0"
            style="border-radius: 50%"
            @click="handel_sort(row,index,'up')"
          >上</Button>
          <Button
            :disabled="index === data.length -1"
            style="border-radius: 50%;margin-left: 5px"
            @click="handel_sort(row,index,'down')"
          >下</Button>
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import apis from "../../http/api";
import OSS from 'ali-oss';

export default {
  name: "faq",
  data() {
    return {
	  ossClient: null,
	  upload_image_data:null,
	  upload_image_name:null,
	  
	  image_for_shop: false,
	  
      filterDiscount: [{ label: '可打折', value: 1 }, { label: '不可打折', value: 0 }],
      filterStatus: [{ label: '正常', value: 0 }, { label: '下架', value: -1 }, { label: '赠品', value: -2 }],
      filterClassify: [{ label: '主题', value: 1 }, { label: '墙纸', value: 2 }, { label: '门', value: 3 },
        { label: '桌子', value: 4 }, { label: '床', value: 5 }, { label: '地板', value: 6 },
        { label: '家具', value: 7 }, { label: '软装', value: 8 }, { label: '窗户', value: 9 },
		{ label: '挂饰', value: 10 }],
      classify: 1,
      filterRoomType: [{ label: '教室&寝室', value: 0 }, { label: '教室', value: 1 }, { label: '寝室', value: 2 }],
      room_type: 0,   // 0 教室&寝室，1教室，2寝室
      data: [],
      tmpData: [],
      modalAdd: false,
	  modalEditImage: false,
      action_btn_disabled: false,
      sortSaveBtn: false,
      update_question: "",
      update_answer: "",
      update_faq_id: null,
      editIndex: -1,
      sorting: false,
      sortBtnDesc: "排序",
      addClassify: 1,
      addImages: "",
      addRoomType: 0,
      addDiscount: 0,
      addJewelPrice: null,
      addCoinPrice: null,
      addStatus: 0,
      updateClassify:'',
      updateImages: "",
      updateRoomType: 0,
      updateDiscount: 0,
      updateJewelPrice: null,
      updateCoinPrice: null,
      updateStatus: 0,
	  modalTagAdd: false,
	  updateTagsIndex: -1,
	  dataTypeTags: [],
	  dataStyleTags: [],
	  updateTagsPropId: -1,
	  updateTagsType: 0,
	  updateTagsStyleFirst: 0,
	  updateTagsStyleSeconds: 0,
	  updateTagsArray:[],
      columns: [
		  {
		    title: '商品ID',
		    slot: 'id',
		    width: 0
		  },
		  {
		    title: '缩略图',
		    slot: 'url',
		    width: 0
		  },
        {
          title: '优先级',
          slot: 'priority',
          width: 80
        },
        {
          title: '类型',
          slot: 'category_id',
          // width: 120
        },
        // {
        //   title: '图片',
        //   slot: 'images',
        //   width: 220
        // },
        {
          title: '房间类型',
          slot: 'room_type',
          // width: 170
        },
        {
          title: '用钻价格',
          slot: 'jewel_price',
          // width: 170
        },
        {
          title: '用币价格',
          slot: 'coin_price',
          // width: 170
        },
        {
          title: '折扣',
          slot: 'discount',
          // width: 170
        },
        {
          title: '状态',
          slot: 'status',
          // width: 170
        },
		// {
		//   title: '标签',
		//   slot: 'tags',
		//   width: 0
		// },
        {
          title: '操作',
          slot: 'action',
          width: 270
        }
      ]
    }
  },
  async created() {
	this.getOss();
    await this.getRecords()
  },
  watch: {
    // 如果退出编辑将多选框置为false
    editIndex: function (newVal, oldVal) {
      if (newVal === -1) {
        this.isUpdateTime = false
      }
    },
    modalAdd: function (newVal, oldVal) {
      if (newVal) {
        this.addClassify = this.classify;
        this.addRoomType = this.room_type
      }
    },
	modalTagAdd: function (newVal, oldVal) {
	  if (newVal) {
	  }
	}
  },
  methods: {
	async getOss() {
	    apis.get_oss().then(res => {
	        this.ossClient = new OSS({
	            region: 'oss-cn-shanghai',
	            accessKeyId: res.AccessKeyId,
	            accessKeySecret: res.AccessKeySecret,
	            stsToken: res.SecurityToken,
	            bucket: 'co-study',
	        })
	    }).catch(err => {
	        console.log(err)
	    })
	},
	
	get_image_size_str(event) {
		let filename = ''
		return new Promise(function(resolve, reject) {
		                let _URL = window.URL || window.webkitURL;
		                let img = new Image();
		                img.onload = function() {
		                    filename =  '_' + img.width + '_' + img.height
							resolve()
		                }
		                img.src = _URL.createObjectURL(event);
		            }).then(() => {
		                return filename;
		            }, () => {
		                this.$message.error('!');
		                return Promise.reject();
		            });
	},
	
	async addImgRecord(event, type) {
	    try {
			console.log(type)
	        let ts = (new Date()).valueOf();
	        let filename = '.' + event.name.split('.').pop();
	        if(filename !== '.png'){
	            this.$Message.error('仅支持上传png格式的图片');
	            return Promise.reject()
	        }
			
			let file_key = event.name.split('.')[0]
			
			var wall_keys = ['front_wall', 'behind_wall', 'left_wall', 'right_wall']
			var door_keys = ['door']
			var seat_keys = ['seat_book_rest', 'seat_other', 'seat_girl', 'seat_self', 'seat_boy', 'seat_front', 'seat_right', 'seat_left', 'seat_book']
			var bed_keys = ['bed_empty', 'bed_sleep', 'bed_black',  'bed_self']
			var floor_keys = ['floor']
			var keys = ['shop']
			keys = keys.concat(wall_keys)
			keys = keys.concat(door_keys)
			keys = keys.concat(seat_keys)
			keys = keys.concat(bed_keys)
			keys = keys.concat(floor_keys)
			if (!keys.find(item => item===file_key)) {
				this.$Message.error('图片名称错误');
				return Promise.reject()
			}		
			
			let timestamp = Date.now()
			timestamp =  parseInt(timestamp/1000)
			
			// let min = 1000
			// let max = 9999
			// parseInt(Math.random()*(max-min+1)+min,10);
			// let random = Math.floor(Math.random()*(max-min+1)+min);
			
			filename = this.$route.query.shop_id +'_'+ timestamp
			
			let tem = await this.get_image_size_str(event)
			var length = 0
			if (this.upload_image_data) {
				length = this.upload_image_data.length
			}
			filename = filename + '_' + length + tem + '.png'
			if (this.classify === null) {
			    this.$Message.error('请先选择类型');
			    return Promise.reject()
			}
			if (type == 0) {
				if (this.upload_image_name === null) {
					this.upload_image_name = ''
				}
				this.upload_image_name += event.name + '\n'
				if (this.upload_image_data === null) {
					this.upload_image_data = []
				}
				this.upload_image_data.push({'key':event.name.split('.')[0], 'filename':filename, 'data':event})
			}
	    } catch (e) {
	        console.log(e);
	        this.$Message.error('失败');
	    }
	    return Promise.reject()
	},
	async upload_image_to_oss(){
		let oss_url = 'app/image/furniture/'
		let result = null
		console.log('start upload image')
		
		
		for (let i = 0; i < this.upload_image_data.length; i++) {
			let tmp_dict = this.upload_image_data[i]
			console.log(tmp_dict['filename'])
			result = await this.ossClient.put(oss_url + tmp_dict['filename'], tmp_dict['data']);
			if (result.res.status === 200) {
				this.$Message.success('上传成功');
			} else {
				console.log(tmp_dict['key'])
			    return false
			}
		}
		return true
	},
    async getRecords() {
      let params = {
        'category_id': this.classify,
        'room_type': this.roomType
		// 'shop_id': this.$route.query.shop_id
      }
      apis.furniture_image_shop_all_records(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.data = data.records
        }
      }).catch(err => {

      })
    },
	showSelectTags(row, index){
	  this.updateTagsPropId = row.id
	  this.updateTagsType = 0
	  this.updateTagsStyleFirst = 0
	  this.updateTagsStyleSeconds = 0
	  this.modalTagAdd = false
	  this.dataStyleTags = []
	  this.dataTypeTags = []
	  this.updateTagsArray = row.tags.split(/[\s\n]/)
	  this.updateTagsIndex = index
      this.getClothesTags(row.room_type)
	},
	getClothesTags(prop_room_type) {
	  let params = {
		'category_ids': this.classify,
		'room_type': prop_room_type,
	  }
	  apis.figure_shop_get_clothes_tags(params).then(res => {
	    const { data, errCode, msg } = res;
	    if (errCode === 0) {
		  data.style_tags.unshift({'id': 0,'title': '空'})
		  this.dataTypeTags = data.type_tags
		  this.dataStyleTags = data.style_tags
		  let hasType = false
		  this.updateTagsArray.forEach(record => {
		    if (typeof (record) === 'string' && record.length > 0) {
			  this.dataTypeTags.forEach(item => {
			    if (typeof (item.title) === 'string' && item.title.length > 0 && record === item.title) {
			  		if(this.updateTagsType === 0){
						this.updateTagsType = item.id
						hasType = true
						return false
					}
			    }
			  });
			  if(hasType === true){
				this.dataStyleTags.forEach(item => {
				  if (typeof (item.title) === 'string' && item.title.length > 0 && record === item.title) {
						if(this.updateTagsStyleFirst === 0){
							this.updateTagsStyleFirst = item.id
						}else if(this.updateTagsStyleSeconds === 0){
							this.updateTagsStyleSeconds = item.id
						}
				  }
				});  
			  }
		    }
		  });
		  this.modalTagAdd = true
	    }else{
		  this.$Message.error('获取标签列表失败');
		}
	  }).catch(err => {
		this.$Message.error('获取标签列表失败');
	  })
	},
	updateTags() {
	  console.log("test info updateTagsPropId :  "+this.updateTagsPropId)
	  console.log("test info updateTagsIndex :  "+this.updateTagsIndex)
	  if (!this.updateTagsPropId>0) {
	    this.$Message.error('请选择商品!');
	    return
	  }		
	  if (this.updateTagsIndex<0) {
	    this.$Message.error('请选择商品');
	    return
	  }
	  if (!this.updateTagsType>0) {
	    this.$Message.error('款式标签不能为空');
	    return
	  }
	  if (this.updateTagsStyleFirst!=0 && this.updateTagsStyleSeconds!=0 && this.updateTagsStyleFirst === this.updateTagsStyleSeconds) {
	    this.$Message.error('风格标签一和风格标签二不能一样！');
	    return
	  }
	  let styleTagIds = ""
	  if(this.updateTagsStyleFirst === 0 && this.updateTagsStyleSeconds === 0){
		  
	  }else if(this.updateTagsStyleFirst === 0 || this.updateTagsStyleSeconds === 0){
		styleTagIds = this.updateTagsStyleFirst == 0 ? ""+this.updateTagsStyleSeconds : ""+this.updateTagsStyleFirst
	  }else{
		styleTagIds = this.updateTagsStyleFirst+","+this.updateTagsStyleSeconds 
	  }
	  console.log("test info styleIds :  "+styleTagIds)
	  let post_data = {
	    figure_image_id: this.updateTagsPropId,
	    type_tag_id: this.updateTagsType,
	   	style_tag_ids: styleTagIds,
	  }
	  apis.figure_shop_post_clothes_bind_tag(post_data).then(res => {
	    const { data, errCode, msg } = res;
	    if (errCode !== 0){
		  console.log("test info error :  "+msg)
	      this.$Message.error(msg);
	    }
	    this.getRecords()
	  })
	},
	async editRecordImage() {
		let upload_result = await this.upload_image_to_oss()
		if (!upload_result) {
				  this.$Message.error('图片上传失败');
				  return
		}
		var images_dict = {}
		for (let i = 0; i < this.upload_image_data.length; i++) {
			let tmp_dict = this.upload_image_data[i]
				images_dict[tmp_dict['key']] = tmp_dict['filename']
		}
		this.upload_image_data = null
		this.upload_image_name = null
		this.addImages = JSON.stringify(images_dict)
		
	},
    async addRecord() {
      if (!this.addJewelPrice) {
        this.$Message.error('钻价格不能为空');
        return
      }
      if (!this.addCoinPrice) {
        this.$Message.error('币价格不能为空');
        return
      }
	  if(this.addClassify === 0){
		  console.log('updaload_', this.addClassify)
	  }else{
		  console.log('上传图片ing')
		  let upload_result = await this.upload_image_to_oss()
		  if (!upload_result) {
		  		  this.$Message.error('图片上传失败');
		  		  return
		  }
	  }
	  var images_dict = {}
	  for (let i = 0; i < this.upload_image_data.length; i++) {
	  	let tmp_dict = this.upload_image_data[i]
		images_dict[tmp_dict['key']] = tmp_dict['filename']
	  }
	  this.upload_image_data = null
	  this.upload_image_name = null
	  this.addImages = JSON.stringify(images_dict)
      let post_data = {
        category_id: this.addClassify,
        room_type: this.addRoomType,
        images: this.addImages,
        jewel_price: this.addJewelPrice,
        coin_price: this.addCoinPrice,
        // discount: this.addDiscount,
        status: this.addStatus,
		shop_id: this.$route.query.shop_id,
      }
	  console.log(post_data)
      await apis.furniture_centre_shop_upload(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.addImages = ""
          this.addJewelPrice = null
          this.addCoinPrice = null
        }else {
          this.$Message.error(msg);
        }
      }).catch(res => {
        this.$Message.error(res.toString());
      })

      await this.getRecords()
    },
    updateRecord(index) {
      if (!this.updateImages) {
        this.$Message.error('图片不能为空');
        return
      }
      if (!this.updateJewelPrice) {
        this.$Message.error('钻价格不能为空');
        return
      }
      if (!this.updateCoinPrice) {
        this.$Message.error('币价格不能为空');
        return
      }
      let post_data = {
        id: this.data[index].id,
        category_id: this.updateClassify,
        room_type: this.updateRoomType,
        images: this.updateImages,
        jewel_price: this.updateJewelPrice,
        coin_price: this.updateCoinPrice,
        discount: this.updateDiscount,
        status: this.updateStatus,
      }
      apis.furniture_shop_update_record(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode !== 0){
          this.$Message.error(msg);
        }
        this.getRecords()
      })
    },
	figureImageSortToTop(index) {
	 
	  let post_data = {
	    furniture_id: this.data[index].id,
	  }
	  apis.furniture_image_shop_sort_top(post_data).then(res => {
	    const { data, errCode, msg } = res;
	    if (errCode !== 0){
	      this.$Message.error(msg);
	    }
	    this.getRecords()
	  })
	},
	editImages(row, index) {
		console.log(row)
		this.modalEditImage=true
	},
    // deleteRecord(row, index) {
    //   this.data.splice(index, 1)
    //   let post_data = {
    //     id: row.id,
    //     classify: this.classify,
    //     records: this.data
    //   }
    //   apis.faq_delete_record(post_data).then(res => {
    //     const { data, errCode, msg } = res;
    //     if (errCode === 0) {
    //       this.refreshRecords()
    //     }
    //   }).catch()
    // },
    handleEdit(row, index) {
      this.action_btn_disabled = false;
      this.updateClassify = row.category_id;
      console.log(row.classify);
      this.updateImages = row.images;
      this.updateRoomType = row.room_type;
      console.log(row.room_type)
      this.updateDiscount = row.discount;
      this.updateJewelPrice = row.jewel_price;
      this.updateCoinPrice = row.coin_price;
      this.updateStatus = row.status;
      console.log(row.status)
      this.editIndex = index;
    },
    handleSave(index) {
      this.action_btn_disabled = true;
      this.updateRecord(index);
      this.editIndex = -1;
    },
	handleEditPage(row, index) {
	  this.$router.push({path:'/shop/shop/manager/edit',query: {shop_id:this.$route.query.shop_id, type:'edit'}})
	},
    sort_btn() {
      this.sorting = !this.sorting
      this.sortSaveBtn = !this.sortSaveBtn
      if (!this.sorting) {
        // 深拷贝
        let tmp = JSON.stringify(this.tmpData)
        this.data = JSON.parse(tmp)
      } else {
        // 深拷贝
        let tmp = JSON.stringify(this.data)
        this.tmpData = JSON.parse(tmp)
      }
    },
    handel_sort(row, index, action) {
      let index2 = action === "up" ? index - 1 : index + 1;
      let index1 = index;
      // 将当前位置的值取出来替换为另一个值并将当前取出来的值赋给另一个值
      this.data[index1] = this.data.splice(index2, 1, this.data[index1])[0]
    },
    sort_save() {
      this.sorting = !this.sorting
      this.sortSaveBtn = !this.sortSaveBtn
      let post_data = {
        records: this.data,
        classify: this.classify,
        room_type: this.roomType
      }
      // apis.image_shop_sort_records(post_data).then(res => {
      //   const { data, errCode, msg } = res;
      //   if (errCode === 0) {
      //     this.getRecords()
      //   }
      // })
    },
    async changeSelect() {
      await this.getRecords()
    },
	handleToTop(row, index) {
	  this.figureImageSortToTop(index);
	}
  },
  computed: {
    sort_btn_msg() {
      return this.sorting ? "取消" : "排序"
    }
  },
  filters:{
    getClassify(val){
      let categoryClassifyMap = {1: '主题', 2: '墙纸', 3: '门', 4: '桌子', 5: '床', 6: '地板', 7: '家具', 8: '软装', 9: '窗户', 10: '挂饰'}
      return categoryClassifyMap[val]
    },
    getRoomType(val){
      if(val === 0) {
        return '教室&寝室'
      }else if(val === 1){
		   return '教室'
	  }else {
        return '寝室'
      }
    },
    getDiscount(val){
      if (val > 0){
        return '可打折'
      }else {
        return '不可打折'
      }
    },
    getStatus(val) {
      if(val === 0){
        return '正常'
      }else if(val === -1){
        return '下架'
      } else if(val === -2){
        return '赠品'
      } else {
        return '异常'
      }
    },
	getTags(val) {
	  if(val === ""){
	    return '暂无'
	  }else {
	    return val
	  }
	},
	getTagsEdit(val) {
	  if(val === ""){
	    return '暂无'
	  }else {
	    return "\n\n\n\n\n\n" + val +"\n\n\n\n\n\n"
	  }
	}
  }
}
</script>

<style lang="stylus" scoped>
.faq /deep/ .ivu-table-cell {
  min-height: 33px;
  display: flex;
  justify-content center;
  align-items: center;
}

.faq {
  margin: 10px;
}

.headers {
  text-align: center;
  margin-bottom: 10px;
}

.headers button {
  margin-left: 10px;
}

.images-text {
  white-space: pre-wrap;
}

</style>